<template>
	<div>
		<Header :currentPage="displayedComponent" />
		<!-- DESKTOP -->
		<div v-if="!isMobile" class="content-admin-dashboard">
			<b-container fluid="md">
				<b-row>
					<b-col class="content-left">
						<AdminDashboardNavigate :activeNavigation="displayedComponent" />
					</b-col>
					<b-col class="content-right">
						<div class="wrap-content">
							<Greeting />
							<div class="content-body">
								<component :is="displayedComponent" />
							</div>
						</div>
					</b-col>
				</b-row>
			</b-container>
		</div>
		<!-- MOBILE -->
		<div v-else class="user-dashboard-mobile">
			<b-container fluid="xl">
				<b-row>
					<b-col class="pd-0">
						<GreetingMobile
							:isAvatar="isAdminMain"
							:isDashboard="isAdminMain"
							:isMessage="userSelected ? true : false"
							:titlePage="pageTitle"
							@isBack="handleBackList"
						/>
					</b-col>
					<b-col cols="12">
						<div class="content-body">
							<component
								:is="displayedComponent"
								@userMessageUserSelected="userSelected = $event"
							/>
						</div>
					</b-col>
				</b-row>
			</b-container>
		</div>
	</div>
</template>
<script>
import Header from '@/components/ui/header';
import AdminDashboardNavigate from '@/components/admin/adminDashboard/adminDashboardNavigate/AdminDashboardNavigate';
import Greeting from '@/components/admin/ui/greeting/Greeting';
import GreetingMobile from '@/components/admin/ui/greetingMobile/GreetingMobile';

import AdminMain from '@/components/admin/adminDashboard/adminMain/AdminMain';
import AdminManageListing from '@/components/admin/adminDashboard/adminManageListing/AdminManageListing';
import AdminManageListingSoldRented from '@/components/admin/adminDashboard/adminManageListing/AdminManageListing';
import AdminApproveListing from '@/components/admin/adminDashboard/adminApproveListing/AdminApproveListing';
import AdminProfile from '@/components/admin/common/profile/Profile';
import AdminMessage from '@/components/admin/common/message/Message';
import AdminManageUsers from '@/components/admin/adminDashboard/adminManageUsers/AdminManageUsers';
import AdminPaymentHistory from '@/components/admin/adminDashboard/adminPaymentHistory/AdminPaymentHistory';
import AdminStatistic from '@/components/admin/adminDashboard/adminStatistic/AdminStatistic';
import AdminEmailTemplatePreview from '@/components/admin/adminDashboard/adminEmailTemplatePreview/AdminEmailTemplatePreview';
import AdminWebsiteConfig from '@/components/admin/adminDashboard/adminWebsiteConfig/AdminWebsiteConfig';
import AdminAddAdmin from '@/components/admin/adminDashboard/adminAddAdmin/AdminAddAdmin';
import AdminManageAgency from '@/components/admin/adminDashboard/adminManageAgency/AdminManageAgency';
import AdminMedia from '@/components/admin/adminDashboard/adminMedia/AdminMedia';
import AdminManageSpecialDeals from '@/components/admin/adminDashboard/adminManageSpecialDeals/AdminManageSpecialDeals';
import AdminDiscountList from '@/components/admin/adminDashboard/adminDiscountList/AdminDiscountList';

import { mapGetters, mapActions, mapState } from 'vuex';

export default {
	components: {
		Header,
		AdminDashboardNavigate,
		Greeting,
		GreetingMobile,
		AdminMain,
		AdminManageListing,
		AdminManageListingSoldRented,
		AdminApproveListing,
		AdminProfile,
		AdminMessage,
		AdminManageUsers,
		AdminPaymentHistory,
		AdminStatistic,
		AdminEmailTemplatePreview,
		AdminWebsiteConfig,
		AdminAddAdmin,
		AdminManageAgency,
		AdminMedia,
		AdminManageSpecialDeals,
		AdminDiscountList
	},
	data() {
		return {
			displayedComponent: 'AdminMain',
			userSelected: null,
			pageTitles: {
				AdminMessage: this.$t('userDashboard.messages.textBox'),
				AdminProfile: this.$t('userDashboard.navigation.mobile.profile'),
				AdminManageListing: this.$t('adminDashboard.navigation.listings'),
				AdminApproveListing: this.$t('adminDashboard.navigation.noticesReview'),
				AdminMangeAgency: this.$t('adminDashboard.navigation.noticesReview'),
				AdminManageSpecialDeals: this.$t('adminDashboard.navigation.adminManageSpecialDeals'),
				AdminDiscountList: this.$t('adminDashboard.navigation.adminDiscountList'),
			}
		};
	},

	computed: {
		...mapGetters('UserController', ['isMobile']),
		isAdminMain() {
			return this.displayedComponent === 'AdminMain' ? true : false;
		},
		pageTitle() {
			return this.pageTitles[this.displayedComponent];
		}
	},
	watch: {
		$route(newVal) {
			this.displayedComponent = newVal.name;
		}
	},
	created() {
		this.displayedComponent = this.$route.name;
	},
	methods: {
		handleBackList() {
			this.userSelected = null;
		}
	}
};
</script>
<style lang="scss">
@import 'adminDashboard.scss';
</style>
